import React from 'react';

import { userManagementNewUserT as translations } from './translations';

import { ContactSupportCTA } from '../shared/ContactSupportCTA';

const Paragraphs = ({ children }: { children: React.ReactNode }) => (
  <div className="space-y-3">{children}</div>
);

export const NewUserFeedback = {
  deactivatedDetected: () => ({
    open: true as const,
    title: translations.createUserDialog.feedback.deactivatedTitle,
    content: (
      <Paragraphs>
        <p>{translations.createUserDialog.feedback.deactivatedBody}</p>
        <ContactSupportCTA
          reachOutPrefix={
            translations.createUserDialog.feedback.contactSupportPrefix
          }
        />
      </Paragraphs>
    ),
    closeDialogOnClose: true
  }),

  success: () => ({
    open: true as const,
    title: translations.createUserDialog.feedback.successTitle,
    content: (
      <Paragraphs>
        <p>{translations.createUserDialog.feedback.successBody}</p>
      </Paragraphs>
    ),
    closeDialogOnClose: true
  }),

  reviewForm: () => ({
    open: true as const,
    title: translations.createUserDialog.feedback.reviewFormTitle,
    content: (
      <Paragraphs>
        <p>{translations.createUserDialog.feedback.reviewFormBody}</p>
      </Paragraphs>
    )
  }),

  genericError: () => ({
    open: true as const,
    title: translations.createUserDialog.feedback.genericErrorTitle,
    content: (
      <Paragraphs>
        <ContactSupportCTA
          reachOutPrefix={
            translations.createUserDialog.feedback.genericErrorBodyPrefix
          }
        />
      </Paragraphs>
    )
  })
};
